import { Box, Button } from '@mui/material';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { NullableTooltip } from '~/components/NullableTooltip';

import { useSxStyles } from './useStyles';

export type BottomActionButtonConfig = {
  disabled: boolean;
  show: boolean;
};

export type BottomActionButtonsProps = {
  activeMemberId?: number;
  absence: BottomActionButtonConfig;
  equipment: BottomActionButtonConfig;
  education: BottomActionButtonConfig;
  rewarding: BottomActionButtonConfig;
  tasks: BottomActionButtonConfig;
};

export const BottomActionButtons = (props: BottomActionButtonsProps) => {
  const { activeMemberId, absence, education, rewarding, equipment, tasks } =
    props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const ButtonWrapper = (
    wrapperProps: BottomActionButtonConfig & { children: ReactNode },
  ) => {
    const { disabled, show, children } = wrapperProps;

    return show ? (
      <NullableTooltip
        title={disabled ? t<string>('disabledFunctionality') : ''}
      >
        <Box sx={sxStyles.tooltipContainer}>{children}</Box>
      </NullableTooltip>
    ) : (
      <></>
    );
  };

  return (
    <>
      <ButtonWrapper {...absence}>
        <Button
          size="small"
          color="primary"
          variant="contained"
          component="a"
          href={
            absence.disabled
              ? ''
              : `/page-ui2-redirect?empId=${activeMemberId}&area=people&subarea=PEOP_ABSENCES`
          }
          disabled={!activeMemberId || absence.disabled}
          data-cy="absences"
        >
          {t('absences')}
        </Button>
      </ButtonWrapper>
      <ButtonWrapper {...education}>
        <Button
          size="small"
          color="primary"
          variant="contained"
          component="a"
          href={
            education.disabled
              ? ''
              : `/page-ui2-redirect?empId=${activeMemberId}&area=development&subarea=DEV_EDUCATION`
          }
          disabled={!activeMemberId || education.disabled}
          data-cy="trainings"
        >
          {t('trainings')}
        </Button>
      </ButtonWrapper>
      <ButtonWrapper {...tasks}>
        <Button
          size="small"
          color="primary"
          variant="contained"
          component="a"
          href={`/page-ui2-redirect?empId=${activeMemberId}&area=people&subarea=PEOP_COLLABORATION`}
          disabled={!activeMemberId}
          data-cy="tasks"
        >
          {t('tasks')}
        </Button>
      </ButtonWrapper>
      <ButtonWrapper {...rewarding}>
        <Button
          size="small"
          color="primary"
          variant="contained"
          component="a"
          href={
            rewarding.disabled
              ? ''
              : `/page-ui2-redirect?empId=${activeMemberId}&area=rewarding&subarea=general`
          }
          disabled={!activeMemberId || rewarding.disabled}
          data-cy="salary"
        >
          {t('salary')}
        </Button>
      </ButtonWrapper>
      <ButtonWrapper {...equipment}>
        <Button
          size="small"
          color="primary"
          variant="contained"
          component="a"
          href={
            equipment.disabled
              ? ''
              : `/page-ui2-redirect?empId=${activeMemberId}&area=people&subarea=PEOP_EQUIPMENT`
          }
          disabled={!activeMemberId || equipment.disabled}
          data-cy="equipment"
        >
          {t('equipment')}
        </Button>
      </ButtonWrapper>
    </>
  );
};
